import script from "./RoutesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RoutesTable.vue?vue&type=script&setup=true&lang=js"

import "./RoutesTable.vue?vue&type=style&index=0&id=890e67f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-890e67f8"]])

export default __exports__